/* tslint:disable */
/* eslint-disable */
/**
 * Tag API
 * API for managing document tags
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateTagRequest interface.
 */
export function instanceOfCreateTagRequest(value) {
    if (!('keyValue' in value) || value['keyValue'] === undefined)
        return false;
    return true;
}
export function CreateTagRequestFromJSON(json) {
    return CreateTagRequestFromJSONTyped(json, false);
}
export function CreateTagRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'keyValue': json['keyValue'],
    };
}
export function CreateTagRequestToJSON(json) {
    return CreateTagRequestToJSONTyped(json, false);
}
export function CreateTagRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'keyValue': value['keyValue'],
    };
}
